import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import Button from '../../Elements/Button/Button';
import Overlay from '../../../hocs/Overlay/Overlay';
import ZohoForm from '../../../hocs/ZohoForm/ZohoForm';
import { translate } from '../../../utils/locale';
import s from './Zoho.scss';

const Zoho = ({ setup, content }) => {
	if (content.zohoPopup) {
		const [showForm, toggleShowForm] = useState(false);
		const toggleFormHandler = () => toggleShowForm((show) => !show);

		return (
			<div className={s.zoho}>
				<Button variantClasses={['button__zoho']} type="button" clickEventHandler={toggleFormHandler}>
					{ translate(setup, content.buttonText) }
				</Button>
				<Overlay variantClasses={['overlay__zoho']} isShowing={showForm} closeOverlayHandler={toggleFormHandler}>
					<ZohoForm setup={setup} htmlBlob={content.zohoForm} multistep={content.zohoMultistepForm} callback={toggleFormHandler} successMessage={content.zohoSuccessMessage} redirect={content.zohoRedirect} />
				</Overlay>
			</div>
		);
	}

	return (
		<ZohoForm setup={setup} htmlBlob={content.zohoForm} multistep={content.zohoMultistepForm} successMessage={content.zohoSuccessMessage} redirect={content.zohoRedirect} />
	);
};

export default hot(module)(Zoho);
